// ============================================================
// LEADCEREBRO SITE CONFIG — the owner edits this one file.
// ============================================================
export const SITE = {
  name: "LeadCerebro",
  domain: "https://leadcerebro.com", // REPLACE with your real domain before launch

  // --- Founding offer ---
  price: 800,
  renewalPerYear: 120,
  totalSpots: 25,
  spotsTaken: 7, // EDIT: increase by 1 every time a founding customer signs up

  // --- Integrations (REPLACE before launch) ---
  calendlyUrl: "https://calendly.com/neogivarsha07/30min",
  ga4Id: "", // e.g. "G-XXXXXXXXXX" — analytics load only after cookie consent
  metaPixelId: "", // e.g. "1234567890"

  // --- Feature flags ---
  showPaymentSplit: true, // 50% to start / 50% before launch
};

export const spotsLeft = SITE.totalSpots - SITE.spotsTaken;
